App.namespace.wrap('es6.views.login.google', function (options = {}) {
  const GoogleLoginManager = App.es6.shared.google_login_manager

  const {
    buttonId,
    googleUrl,
    googleClientId,
    csrfToken,
    redirectUrl,
    defaultRedirectUrl = '/account/enquiries/current',
    trackingParams = {}
  } = options

  const callback = options.callback ?? (() => {
    if (redirectUrl && redirectUrl.indexOf(location.origin) === 0) {
      window.location = redirectUrl;
      return;
    }

    window.location = defaultRedirectUrl
  });

  const init = () => {
    const googleLoginOptions = {
      buttonId,
      googleUrl,
      googleClientId,
      csrfToken,
      callback,
      prompt: false,
      autoLoginOnClick: true,
      trackingParams,
    }
    return GoogleLoginManager(googleLoginOptions).init();
  }

  return {
    init
  }
});
